export default class TypeValueUtils {
	static isString(value) {
		return typeof value === 'string'
	}

	static isNumber(value) {
		return typeof value === 'number'
	}

	static isArray(value) {
		return Array.isArray(value)
	}

	static isBoolean(value) {
		return typeof value === 'boolean'
	}
}
